import { render, staticRenderFns } from "./IconLoadingBuffer.vue?vue&type=template&id=153f02f1"
import script from "./IconLoadingBuffer.vue?vue&type=script&lang=js"
export * from "./IconLoadingBuffer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports